import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/notification.service';
import { InvoiceSalary } from 'src/app/shared/InvoiceSalary.model';
import { InvoiceSalaryService } from 'src/app/shared/InvoiceSalary.service';
import { InvoiceSalaryDetail } from 'src/app/shared/InvoiceSalaryDetail.model';
import { InvoiceSalaryDetailService } from 'src/app/shared/InvoiceSalaryDetail.service';
import { Membership } from 'src/app/shared/Membership.model';
import { MembershipService } from 'src/app/shared/Membership.service';
import { Product } from 'src/app/shared/Product.model';
import { ProductService } from 'src/app/shared/Product.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { DownloadService } from 'src/app/shared/Download.service';

@Component({
  selector: 'app-invoice-salary-detail-history',
  templateUrl: './invoice-salary-detail-history.component.html',
  styleUrls: ['./invoice-salary-detail-history.component.css']
})
export class InvoiceSalaryDetailHistoryComponent implements OnInit {

  ID: number = environment.InitializationNumber;
  isShowLoading: boolean = false;
  searchString: string = environment.InitializationString;
  dateTimeBegin: Date = new Date();
  dateTimeEnd: Date = new Date();
  total: number = environment.InitializationNumber;
  MembershipID: number = environment.InitializationNumber;
  dataSource: MatTableDataSource<any>;
  displayColumns: string[] = ['DateCreated', 'SupplierID', 'Quantity', 'Price', 'Note', 'Total', 'Save'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public InvoiceSalaryService: InvoiceSalaryService,
    public InvoiceSalaryDetailService: InvoiceSalaryDetailService,
    public MembershipService: MembershipService,
    public ProductService: ProductService,
    public NotificationService: NotificationService,
    public DownloadService: DownloadService,
  ) {

  }
  ngOnInit(): void {
    this.GetMembershipToListAsync();
    this.GetToList();
  }
  onChangeDateTimeBegin(value) {
    this.dateTimeBegin = new Date(value);
  }
  onChangeDateTimeEnd(value) {
    this.dateTimeEnd = new Date(value);
  }
  onSearch() {
    this.GetMembershipToListAsync();
    if (this.searchString.length > 0) {
      this.dataSource.filter = this.searchString.toLowerCase();
    }
    else {
      this.GetToList();
    }
  }
  GetMembershipToListAsync() {
    this.MembershipService.GetAllAndEmptyToListAsync().subscribe(
      res => {
        this.MembershipService.list = (res as Membership[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
      },
      err => {
      }
    );
  }  
  GetToList() {
    this.isShowLoading = true;
    this.InvoiceSalaryDetailService.GetByDateTimeBeginAndDateTimeEndAndSearchStringToListAsync(this.dateTimeBegin, this.dateTimeEnd, this.searchString).subscribe(
      res => {
        this.InvoiceSalaryDetailService.list = res as InvoiceSalary[];
        if (this.InvoiceSalaryDetailService.list) {
          this.dataSource = new MatTableDataSource(this.InvoiceSalaryDetailService.list.sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1)));
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.total = environment.InitializationNumber;
          for (let i = 0; i < this.InvoiceSalaryDetailService.list.length; i++) {
            this.total = this.total + this.InvoiceSalaryDetailService.list[i].Total;
          }
        }
        this.isShowLoading = false;
      },
      err => {
        this.isShowLoading = false;
      }
    );
  }
  onChangeDateCreated(element: InvoiceSalaryDetail, value) {
    element.DateCreated = new Date(value);
  }
  onSave(element: InvoiceSalaryDetail) {
    this.InvoiceSalaryDetailService.SaveAsync(element).subscribe(
      res => {
        this.GetToList();
        this.NotificationService.warn(environment.SaveSuccess);
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
      }
    );
  }
  onDelete(element: InvoiceSalaryDetail) {
    if (confirm(environment.DeleteConfirm)) {
      this.InvoiceSalaryDetailService.RemoveAsync(element.ID).subscribe(
        res => {
          this.GetToList();
          this.NotificationService.warn(environment.DeleteSuccess);
        },
        err => {
          this.NotificationService.warn(environment.DeleteNotSuccess);
        }
      );
    }
  }
}
